import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ec5a831")

_pushScopeId("data-v-3ec5a831")
const _hoisted_1 = { class: "mt-10 mb-32" }
const _hoisted_2 = { class: "flex justify-start w-full mgb-16" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-xl" }, null, -1)
const _hoisted_4 = { class: "w-full text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "icon-tooltip" }
const _hoisted_7 = { class: "tooltiptext" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-edit-square text-2xl hover:text-blue-600 cursor-pointer text-gray-333" }, null, -1)
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "icon-tooltip" }
const _hoisted_11 = { class: "tooltiptext" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-trash text-2xl hover:text-blue-600 cursor-pointer" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Button, { class: "btn-light-blue w-30 h-10 mb-6" }, {
        default: _withId(() => [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.t('signUp')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        data: _ctx.data,
        headers: _ctx.headers
      }, {
        display_image: _withId(({ item }) => [
          _createVNode("div", {
            class: "display_image",
            style: { background: item.background, borderColor: item.border }
          }, _toDisplayString(item.display_image), 5)
        ]),
        edit: _withId(({}) => [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t('actionEdit')), 1),
              _hoisted_8
            ])
          ])
        ]),
        delete: _withId(({}) => [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('actionDelete')), 1),
              _hoisted_12
            ])
          ])
        ]),
        _: 1
      }, 8, ["data", "headers"])
    ])
  ]))
})